<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <span class="breadcrumbs__title">Crear / Editar</span>
        <v-icon>mdi-chevron-right</v-icon>
        <span>Suplido</span>
        <v-divider class="mt-2"></v-divider>
        <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
        <v-row class="mt-10">
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title class="text-h6">Información Básica</v-card-title>
              <div class="separator"></div>
              <v-divider></v-divider>
              <v-card-text class="text--primary pt-6">
                <v-form ref="form" v-model="valid" lazy-validation width="100%">
                  <v-row class="dense_layout">
                    <v-col cols="3">
                      <v-autocomplete
                        :disabled="!disableNotPtomoter"
                        v-model="supplied.company"
                        :items="contractingCompanies"
                        outlined
                        label="Destinataria"
                        item-text="name"
                        item-value="id"
                        :rules="dropDownField"
                        required
                      ></v-autocomplete
                    ></v-col>
                    <v-col cols="3">
                      <v-text-field
                        :disabled="!disableNotPtomoter"
                        v-model="supplied.supplierCompany"
                        label="Empresa Proveedora"
                        :rules="emptyField"
                        required
                        outlined
                      ></v-text-field
                    ></v-col>
                    <v-col cols="3">
                      <v-row no-gutters>
                        <v-col cols="10">
                          <v-file-input
                            :disabled="!disableNotPtomoter"
                            label="Archivo Factura PDF"
                            v-model="suppliedFile"
                            :rules="emptyField"
                            required
                          ></v-file-input>
                        </v-col>
                        <v-col cols="2" class="mt-3">
                          <v-icon
                            large
                            v-if="supplied.PDFSuppliedFile"
                            @click="
                              downloadFile(
                                supplied.PDFSuppliedFile,
                                supplied.PDFSuppliedFileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3">
                      <v-row no-gutters>
                        <v-col cols="10">
                          <v-file-input
                            :disabled="!disableNotPtomoter"
                            label="Archivo email"
                            v-model="emailFile"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="2" class="mt-3">
                          <v-icon
                            large
                            v-if="supplied.emailFile"
                            @click="
                              downloadFile(
                                supplied.emailFile,
                                supplied.emailFileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="dense_layout">
                    <v-col cols="3">
                      <v-text-field
                        :disabled="!disableNotPtomoter"
                        v-model="supplied.suppliedNumber"
                        label="Numero Factura"
                        outlined
                        :rules="emptyField"
                        required
                      ></v-text-field
                    ></v-col>
                    <v-col cols="3"
                      ><v-menu
                        :disabled="!disableNotPtomoter"
                        v-model="ff"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="!disableNotPtomoter"
                            v-model="supplied.suppliedDate"
                            label="Fecha Factura"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :rules="emptyField"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="supplied.suppliedDate"
                          @input="ff = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker> </v-menu
                    ></v-col>
                    <!-- <v-col cols="3"
                      ><v-menu
                        v-model="fv"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="supplied.expirationDate"
                            label="Fecha vencimiento"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="supplied.expirationDate"
                          @input="fv = false"
                          locale="es-ES"
                        ></v-date-picker> </v-menu
                    ></v-col>
                    <v-col cols="3"
                      ><v-menu
                        v-model="fp"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="supplied.paymentDate"
                            label="Fecha de pago"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="supplied.paymentDate"
                          @input="fp = false"
                          locale="es-ES"
                        ></v-date-picker> </v-menu
                    ></v-col>
                    <v-col cols="3"
                      ><v-menu
                        v-model="fc"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="supplied.postingDate"
                            label="Fecha contabilización"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="supplied.postingDate"
                          @input="fc = false"
                          locale="es-ES"
                        ></v-date-picker> </v-menu
                    ></v-col> -->
                  </v-row>
                  <v-row class="dense_layout">
                    <v-col cols="4"
                      ><v-autocomplete
                        :disabled="!disableNotPtomoter"
                        v-model="associatedFile"
                        :items="getContracts"
                        outlined
                        label="Expediente asociado "
                        item-text="awardPropJustification.fileName"
                        item-value="id"
                        :rules="dropDownField"
                        required
                      ></v-autocomplete
                    ></v-col>
                    <v-col cols="4">
                      <v-autocomplete
                        v-model="associatedBill"
                        :items="getAssociatedBills"
                        outlined
                        label="Factura asociada"
                        item-text="billNumber"
                        item-value="id"
                        :rules="dropDownField"
                        required
                        :readonly="!availableAssociatedBill"
                        :disabled="
                          !availableAssociatedBill || !disableNotPtomoter
                        "
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="dense_layout">
                    <v-col cols="3">
                      <CurrencyInput
                        v-model="supplied.taxBase"
                        label="Base imponible"
                        outlined
                        :rules="emptyField"
                        required
                        :readonly="!availableAssociatedBill"
                        :disabled="
                          !availableAssociatedBill || !disableNotPtomoter
                        "
                        @formatWithCurrency="formatWithCurrency('taxBase')"
                    /></v-col>
                    <v-col cols="3">
                      <CurrencyInput
                        v-model="supplied.totalVAT"
                        @formatWithCurrency="formatWithCurrency('totalVAT')"
                        label="Total IVA"
                        outlined
                        :readonly="!availableAssociatedBill"
                        :disabled="
                          !availableAssociatedBill || !disableNotPtomoter
                        "
                    /></v-col>
                    <v-col cols="3">
                      <CurrencyInput
                        v-model="supplied.totalWithholding"
                        @formatWithCurrency="
                          formatWithCurrency('totalWithholding')
                        "
                        label="Total Retencion"
                        outlined
                        :readonly="!availableAssociatedBill"
                        :disabled="
                          !availableAssociatedBill || !disableNotPtomoter
                        "
                    /></v-col>
                    <v-col cols="3">
                      <CurrencyInput
                        v-model="supplied.remainingProjectAmount"
                        label="Importe total suplido"
                        outlined
                        :rules="zeroOrHigher"
                        required
                        :readonly="true"
                        disabled
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-divider class="mb-2"></v-divider>
              <v-card-actions class="pl-4">
                <v-btn
                  class="mb-5 white--text px-8"
                  :disabled="!valid || !disableNotPtomoter"
                  color="primary"
                  @click="submit"
                  >Guardar</v-btn
                >
              </v-card-actions>
              <!-- <small class="pl-4"
                >Revise todos los campos marcados en rojo antes de poder
                guardar.</small
              > -->
              <br />
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import formatters from "@/utils/formatters.js";
import fieldValidation from "@/utils/fieldValidation.js";
import { mapGetters, mapActions } from "vuex";
import Snackbar from "@/components/Snackbar";
import services from "@/services/services";
import router from "@/router";
import CurrencyInput from "@/components/CurrencyInput.vue";
export default {
  name: "CreateEditSupplied",
  props: ["id"],
  components: {
    Snackbar,
    CurrencyInput,
  },
  data() {
    return {
      test: 0,
      suppliedFile: null,
      emailFile: null,
      availableAssociatedBill: false,
      associatedFileObj: null,
      associatedBillObj: null,
      textError: null,
      isSnackbar: false,
      valid: true,
      amountToShow: {
        // Base imponible
        taxBase: 0,
        totalVAT: 0,
        // Total Retención
        totalWithholding: 0,
        remainingProjectAmount: 0,
      },
      date: new Date().toISOString().substr(0, 10),
      ff: false,
      fv: false,
      fp: false,
      fc: false,
      // contractingCompanies: [
      //   { id: 1, name: "Trambesòs" },
      //   { id: 2, name: "Tram de Barcelona" },
      // ],
      suppliedID: null,
      remainingProjectAmount: 0,
      totalAmount: 0,
      supplied: {
        type: "supplied",
        company: "",
        suppliedNumber: "",
        PDFSuppliedFile: null,
        PDFSuppliedFileName: null,
        emailFile: null,
        emailFileName: null,
        suppliedDate: "",
        expirationDate: "",
        paymentDate: "",
        // Fecha contabilización
        postingDate: "",
        promoter: "",
        bill: "",
        associatedFile: "",
        associatedBill: "",
        // Base imponible
        taxBase: 0,
        totalVAT: 0,
        // Total Retención
        totalWithholding: 0,
        remainingProjectAmount: 0,
        supplier: "",
      },
      dropDownField: [(v) => fieldValidation.dropDownValidation(v)],
      emptyField: [(v) => fieldValidation.emptyField(v)],
      zeroOrHigher: [(v) => fieldValidation.zeroOrHigher(v)],
      supplierCompany: "",
    };
  },
  methods: {
    ...mapActions(["setActionsLoader"]),
    async submit() {
      if (this.$refs.form.validate()) {
        this.setActionsLoader(true);
        // this.associatedFileObj.awardPropJustification.remainingProjectAmount =
        //   this.remainingProjectAmount;
        if (this.getUserData && !this.supplied.promoter) {
          this.supplied.promoter = this.getUserData.id;
        }
        if (this.associatedBillObj && !this.supplied.supplier) {
          this.supplied.supplier = this.associatedBillObj.supplier;
        }
        this.supplied.remainingProjectAmount = this.remainingProjectAmount;
        // this.associatedBillObj.remainingProjectAmount =
        //   this.remainingProjectAmount;
        if (this.id) {
          Promise.all(this.uploadFilse(this.id))
            .then((urlsData) => {
              urlsData.forEach((url) => {
                if (url.includes("suppliedFile.")) {
                  this.supplied.PDFSuppliedFile = url;
                } else if (url.includes("emailFile.")) {
                  this.supplied.emailFile = url;
                }
              });
              this.update();
            })
            .catch((error) => {
              this.setActionsLoader(false);
              console.log(`Some failed: `, error.message);
            });
        } else {
          // this.supplied.promoter = this.getUserData.id;
          let isSaved = await this.save();
          if (isSaved) {
            Promise.all(this.uploadFilse(this.suppliedID))
              .then((urlsData) => {
                urlsData.forEach((url) => {
                  if (url.includes("suppliedFile.")) {
                    this.supplied.PDFSuppliedFile = url;
                  } else if (url.includes("emailFile.")) {
                    this.supplied.emailFile = url;
                  }
                });
                this.update();
              })
              .catch((error) => {
                this.setActionsLoader(false);
                console.log(`Some failed: `, error.message);
              });
          }
        }
      }
    },
    formatWithCurrency(field) {
      //console.log(field);
      if (
        field === "taxBase" ||
        field === "totalVAT" ||
        field === "totalWithholding"
      ) {
        //const oldTaxBase = this.supplied[field];
        // this.supplied[field] = this.amountToShow[field];
        // this.amountToShow[field] = formatters.amountFormatter.format(
        //   this.amountToShow[field]
        // );
        // let total = this.supplied.remainingProjectAmount;
        //console.log(total);
        this.remainingProjectAmount =
          // total +
          parseFloat(this.supplied.taxBase) +
          parseFloat(this.supplied.totalVAT) -
          parseFloat(this.supplied.totalWithholding);
        this.supplied.remainingProjectAmount = this.remainingProjectAmount;
        // this.amountToShow.remainingProjectAmount =
        //   formatters.amountFormatter.format(
        //     parseFloat(this.remainingProjectAmount)
        //   );
      }
    },
    async save() {
      let that = this;
      return new Promise((resolve, reject) => {
        services
          .saveData("invoices", this.supplied)
          .then((data) => {
            this.setActionsLoader(false);
            that.suppliedID = data.id;
            this.textError = null;
            this.isSnackbar = true;
            resolve(true);
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
            reject(false);
          });
      });
    },
    async update() {
      //let that = this;
      return new Promise((resolve, reject) => {
        services
          .updateData("invoices", {
            id: this.id || this.suppliedID,
            payload: this.supplied,
          })
          .then(() => {
            // if (
            //   that.associatedFileObj &&
            //   that.associatedFileObj.awardPropJustification.fileName !==
            //     "No hay expediente asociado"
            // ) {
            //   Promise.all([
            //     that.updateAssociatedObj(
            //       "contracts",
            //       this.associatedFile,
            //       this.associatedFileObj
            //     ),
            //   ])
            //     .then(() => {
            //       setTimeout(() => {
            //         router.push("/invoices");
            //       }, 300);
            //     })
            //     .catch(() => {
            //       this.setActionsLoader(false);
            //       this.textError =
            //         "Algo salió mal. Por favor, vuelva a intentarlo";
            //       this.isSnackbar = true;
            //       reject(false);
            //     });
            // } else {
            setTimeout(() => {
              //router.push("/invoices/3");
              router.go(-1);
            }, 300);
            // }
            this.setActionsLoader(false);
            this.textError = null;
            this.isSnackbar = true;
            resolve(true);
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
            reject(false);
          });
      });
    },
    updateAssociatedObj(collection, objId, obj) {
      return new Promise((resolve, reject) => {
        services
          .updateData(collection, {
            id: objId,
            payload: obj,
          })
          .then(() => {
            this.setActionsLoader(false);
            this.textError = null;
            this.isSnackbar = true;
            resolve(true);
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
            reject(false);
          });
      });
    },
    uploadFilse(suppliedId) {
      let filesPromises = [];
      if (this.suppliedFile && this.suppliedFile.type !== "text/plain") {
        filesPromises.push(
          services.files.uploadFile(
            "invoices",
            "suppliedFile." + suppliedId + "-" + this.suppliedFile.name,
            this.suppliedFile
          )
        );
      }
      if (this.emailFile && this.emailFile.type !== "text/plain") {
        filesPromises.push(
          services.files.uploadFile(
            "invoices",
            "emailFile." + suppliedId + "-" + this.emailFile.name,
            this.emailFile
          )
        );
      }
      return filesPromises;
    },
    downloadFile(dataUrl, filename) {
      services.downloadFile(dataUrl, filename);
    },
  },
  computed: {
    ...mapGetters(["getUserData", "getInvoices", "getContracts", "getCompany"]),
    associatedFile: {
      get() {
        return this.supplied.associatedFile;
      },
      set(id) {
        this.supplied.associatedFile = id;
        this.associatedFileObj = this.getContracts.find(
          (item) => item.id === id
        );
        this.availableAssociatedBill = true;
      },
    },
    associatedBill: {
      get() {
        return this.supplied.associatedBill;
      },
      set(id) {
        this.supplied.associatedBill = id;
        this.associatedBillObj =
          this.getInvoices &&
          this.getInvoices.find(
            (item) =>
              item.associatedFile === this.supplied.associatedFile &&
              item.type !== "supplied"
          );
      },
    },
    getAssociatedBills() {
      return this.getInvoices
        ? this.getInvoices.filter(
            (item) =>
              item.associatedFile === this.supplied.associatedFile &&
              item.type !== "supplied"
          )
        : [];
    },
    contractingCompanies() {
      return this.getCompany.filter((item) => item.id !== 3);
    },
    isPromotor() {
      return (
        this.getUserData &&
        this.getUserData.role.includes(3) &&
        this.getUserData.id === this.supplied.promoter
      );
    },
    disableNotPtomoter() {
      return (
        this.isPromotor || (this.getUserData && this.getUserData.superAdmin)
      );
    },
  },
  watch: {
    getInvoices() {
      if (this.id && this.getInvoices) {
        this.supplied = Object.assign(
          {},
          this.getInvoices.find((item) => item.id === this.id)
        );
      }
    },
    supplied() {
      if (this.supplied.PDFSuppliedFile) {
        this.suppliedFile = new File(
          [this.supplied.PDFSuppliedFile],
          this.supplied.PDFSuppliedFileName,
          {
            type: "text/plain",
          }
        );
      }
      if (this.supplied.emailFile) {
        this.emailFile = new File(
          [this.supplied.emailFile],
          this.supplied.emailFileName,
          {
            type: "text/plain",
          }
        );
      }
      // const { taxBase, totalVAT, totalWithholding } = this.supplied;
      this.availableAssociatedBill = true;
      this.associatedFileObj = this.getContracts.find(
        (item) => item.id === this.associatedFile
      );
      this.associatedBillObj = this.getInvoices.find(
        (item) =>
          item.associatedFile === this.supplied.associatedFile &&
          item.type !== "supplied"
      );
      // this.supplied.remainingProjectAmount =
      //   this.associatedFileObj.awardPropJustification.remainingProjectAmount;
      //this.totalAmount = parseFloat(this.supplied.remainingProjectAmount);
      // this.amountToShow = {
      //   remainingProjectAmount: formatters.amountFormatter.format(
      //     parseFloat(this.supplied.remainingProjectAmount)
      //   ),
      //   // Base imponible
      //   taxBase: formatters.amountFormatter.format(parseFloat(taxBase)),
      //   totalVAT: formatters.amountFormatter.format(parseFloat(totalVAT)),
      //   // Total Retención
      //   totalWithholding: formatters.amountFormatter.format(
      //     parseFloat(totalWithholding)
      //   ),
      // };
    },
    // associatedFile() {
    //   // let allBills = this.getInvoices.filter(
    //   //   (item) =>
    //   //     item.type === "received" &&
    //   //     item.associatedFile === this.associatedFile
    //   // );
    //   // this.totalAmount =
    //   //   parseFloat(this.associatedFileObj.awardPropJustification.amount) -
    //   //   allBills.reduce((accum, obj) => accum + parseFloat(obj.totalTopay), 0);
    //   this.totalAmount = parseFloat(
    //     this.associatedFileObj.awardPropJustification.remainingProjectAmount
    //   );
    // },
    suppliedFile() {
      this.supplied.PDFSuppliedFileName = this.suppliedFile.name;
    },
    emailFile() {
      this.supplied.emailFileName = this.emailFile.name;
    },
    id() {
      if (this.id === undefined) {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    },
  },
  mounted() {},
  created() {
    this.supplied.promoter = this.getUserData && this.getUserData.id;
    if (this.id && this.getInvoices) {
      this.supplied = Object.assign(
        {},
        this.getInvoices.find((item) => item.id === this.id)
      );
      // const { taxBase, totalVAT, totalWithholding } = this.supplied;
      this.availableAssociatedBill = true;
      this.associatedFileObj = this.getContracts.find(
        (item) => item.id === this.associatedFile
      );
      this.associatedBillObj = this.getInvoices.find(
        (item) =>
          item.associatedFile === this.supplied.associatedFile &&
          item.type !== "supplied"
      );
      // this.supplied.remainingProjectAmount =
      //   this.associatedFileObj.awardPropJustification.remainingProjectAmount;
      // this.amountToShow = {
      //   remainingProjectAmount: formatters.amountFormatter.format(
      //     parseFloat(this.supplied.remainingProjectAmount)
      //   ),
      //   // Base imponible
      //   taxBase: formatters.amountFormatter.format(parseFloat(taxBase)),
      //   totalVAT: formatters.amountFormatter.format(parseFloat(totalVAT)),
      //   // Total Retención
      //   totalWithholding: formatters.amountFormatter.format(
      //     parseFloat(totalWithholding)
      //   ),
      // };
    }
    // else {
    //   this.amountToShow = {
    //     remainingProjectAmount: formatters.amountFormatter.format(0),
    //     // Base imponible
    //     taxBase: formatters.amountFormatter.format(0),
    //     totalVAT: formatters.amountFormatter.format(0),
    //     // Total Retención
    //     totalWithholding: formatters.amountFormatter.format(0),
    //   };
    // }
  },
};
</script>

<style scoped>
.v-icon.v-icon:after {
  background-color: white;
}
small {
  display: block;
  margin-top: -20px;
}
.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
  margin: 0;
  display: inline-block;
}

.theme--light.v-image {
  align-self: center;
  border-radius: 10%;
}

.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
  margin: 0;
}

.col-6 {
  padding: 0 12px;
}
</style>
